import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { getToken } from '../utils/utils';

const Navbar = () => {
  // const auth = useSelector(state => state.auth.authenticated);
  const { token } = getToken('zenon_token') || '';
  const renderAuthLinks = () => {
    if (token) {
      return (
        <Fragment>
          <li className="nav-item">
            <Link to='/Shop' className="nav-link" >
              Shop
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/cart' className="nav-link" >
              Cart
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/Sell' className="nav-link" >
              Sell
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/Logout' className="nav-link" >
              Logout
            </Link>
          </li>
        </Fragment>
      )
    } else {
      return (
        <Fragment>

          <li className="nav-item">
            <Link to='/auth' className="nav-link" >
              Auth
            </Link>
          </li>
        </Fragment>
      )
    }
  }
  return (
    <Fragment>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark text-white bg-faded">
        <a className="navbar-brand mx-auto" href="/">Zenon</a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            {renderAuthLinks()}
          </ul>
        </div>
      </nav>
    </Fragment>
  );
 };

export default Navbar